import axios from '../utils/axios/index.js';

export const rechargeActivityApi = (params) => {
  return axios.post(`api/ftd/check`, params)
}
export const rechargeActivityClaimApi = (params) => {
  return axios.post(`api/ftd/claim`, params)
}


export const dailyRewardGetApi = (params) => {
  return axios.post(`api/dailywheel/check`, params)
}
export const dailyRewardClaimApi = (params) => {
  return axios.post(`api/dailywheel/claim`, params)
}
export const invitationActivityApi = (params) => {
  return axios.post('api/invitationactivity/check', params)
}
export const invitationActivityClaimApi = (params) => {
  return axios.post('api/invitationactivity/claim', params)
}

export const lossReliefActivityApi = (params) => {
  return axios.post('api/dailyrescue/check', params)
}
export const lossReliefActivityClaimApi = (params) => {
  return axios.post('api/dailyrescue/claim', params)
}


// PARAMS: member_id
export const rechargeRebateActivityCheckApi = (params) => {
  return axios.post('api/rechargerebate/check', params)
}

// PARAMS: member_id
export const rechargeRebateActivityClaimApi = (params) => {
  return axios.post('api/rechargerebate/claim', params)
}

// name - name of the member
// site - site belonging to the member
export const spinWheelActivityCheckApi = (params) => {
  return axios.post('api/lotterywheel/check', params)
}

// name - name of the member
// site - site belonging to the member
export const spinWheelActivityClaimApi = (params) => {
  return axios.post('api/lotterywheel/claim', params)
}

export const getActivityDetailsApi = (params) => {
  return axios.get(`api/activitydetails/get?lang=${params.lang}`)
}


// WEBPACK FOOTER //
// ./src/api/activity.js